import axios from "@/axios";
import Util from '../../util/util';

export const namespaced = true

export const state = {
    operationTheatres: [],
}

export const getters = {
    allOperationTheatres: function (state) {
        return state.operationTheatres;
    }
}

export const mutations = {
    SET_OPERATION_THEATRES(state, response) {
        let operationTheatres = response.data;

        if (!Util.isNullOrEmpty(operationTheatres)) {
            operationTheatres.sort(Util.sortAscByName);
        }

        state.operationTheatres = operationTheatres;
    },
}

export const actions = {
    async getAllOperationTheatres({ commit, state }) {
            try {
                const response = await axios.get("/api/theaters");
                commit('SET_OPERATION_THEATRES', response);
            } catch (error) {
                console.log("ERROR: ", error); //not handelled
            }
    }
}
